import { render } from "./homebanner-two.vue?vue&type=template&id=fd0f874e"
import script from "./homebanner-two.vue?vue&type=script&lang=js"
export * from "./homebanner-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__